/* Zoekbalk in de header (DIEK, okt 2026): kleine aanvullingen op het stock-gedrag van assets/search.js, zonder dat
   bestand te wijzigen.
   1. Escape of wegtabben (focus buiten het formulier) sluit het suggestiepaneel (search.js sluit alleen bij klik buiten).
   2. aria-expanded op de combobox volgt de zichtbaarheid van het paneel.
   3. Vangnet: wordt search.js niet door de Search-drawer-sectie geladen (sectie uit de overlay-groep gehaald),
      dan laden we het hier alsnog, één keer. */
(function () {
  var OPEN = 'predictive-search-open';

  function closePanel(form) {
    document.body.classList.remove(OPEN);
    var input = form.querySelector('input[type="search"]');
    if (input && document.activeElement === input) input.blur();
  }

  function init(form) {
    if (form.dataset.headerSearchReady) return;
    form.dataset.headerSearchReady = 'true';
    var input = form.querySelector('input[type="search"]');

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closePanel(form); }
    });
    form.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !form.contains(e.relatedTarget)) closePanel(form);
    });

    if (input && window.MutationObserver) {
      var sync = function () {
        var open = document.body.classList.contains(OPEN);
        input.setAttribute('aria-expanded', String(open));
      };
      new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
  }

  function boot() {
    document.querySelectorAll('.header__search form').forEach(init);
    var wrap = document.querySelector('.header__search[data-search-js]');
    if (wrap && !customElements.get('predictive-search') && !document.querySelector('script[data-header-search-fallback]')) {
      var s = document.createElement('script');
      s.src = wrap.dataset.searchJs; s.defer = true; s.setAttribute('data-header-search-fallback', '');
      document.head.appendChild(s);
    }
  }
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
